export default __webpack_public_path__ + "3884243f543080637c54b4b7b5612a44.ogg";